import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_SD__base extends INVOCATION__base {
  get family(): ENUM__ml_asset_family {
    return ENUM__ml_asset_family.SD_1;
  }
}
